import React from 'react';
import { Link } from "react-router-dom";
import Auth from "../../services/Auth.service";
import { useTranslation } from "react-i18next";
import GroupListComponents from "../../components/GroupComponents/GroupListComponents";
export default function ListGroups() {

    const { t } = useTranslation();

    return (
        <div>
            {Auth.isUserLoged ? <div>
                <br />
                <div className="container-fluid">
                    <div className="col-12 col-lg-11 mx-auto">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to={'/home/'}>{t("Home_Breadcrumb_Title")}</Link></li>
                                    <li className="breadcrumb-item"><Link to={'/Groups/'}>{t("Global_Label_Text_Groups")}</Link></li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>

                <div>
                    <GroupListComponents />
                </div>
                <br />
            </div > : ""}
        </div>
    );

}
